module.exports = "./img/d6aa76fb32f75c8a26309f7d1bdb29a3.jpg";